<template>
  <div>
    <verte v-model="selected_color" picker="square" model="rgb">
        <svg viewBox="0 0 24 24">
          <path  d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"/>
        </svg>
    </verte>
    <input ref="color" type="hidden" :name="input_name" :value="selected_color">
  </div>
</template>
<style type="text/css">
  .verte__guide{
    width: 60px;
    height: 40px;
  }
</style>
<script>
  import Verte from 'verte';
  import 'verte/dist/verte.css';
  export default {
    components: { Verte }, // window.VueSwatches.default - from CDN
    props: { 
      color: {
        default: '#FF005C',
        type: String
      },
      name: {
        type: String
      }
    },
    data () {
      return {
        selected_color: this.color,
        input_name: this.name
      }
    }
  }
</script>
